// styles
import { themeOptions } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledSignatureModal = styled.div`
  .sm-wrapper {
    padding: 24px 28px 28px;
    position: relative;

    &-box {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;

      &-title {
        display: flex;
        align-items: end;
        justify-content: space-between;
        margin-bottom: 8px;

        &.noFlex {
          display: block;
        }

        > h3 {
          text-align: left;
          color: #222;
          font-size: 14px;
          font-weight: 600;
          line-height: 21px;
        }

        > div {
          > button {
            box-shadow: none !important;
          }
        }

        .risk-type {
          display: flex;
          align-items: center;
          justify-content: space-between;

          > div {
            > button {
              box-shadow: none !important;
            }
          }
        }
      }

      &-content {
        &.border {
          border-radius: 6px;
          border: 1px solid ${themeOptions.palette.gray.border};

          > p {
            width: 342px;
            height: 116px;
            display: flex;
            justify-content: center;
            align-items: center;

            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
            line-height: 21px;
            text-align: center;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: ${themeOptions.palette.error.main};
          }

          > img {
            width: 342px;
            height: 116px;
            object-fit: contain;
          }
        }
      }
    }

    &-footer {
      position: absolute;
      right: 28px;
      bottom: 0px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
    }
  }
`;
